import React,{useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ThreeBoxComponent } from './Three';
import { subscribe } from 'valtio';
import { state } from './Three/store';
import logoBig from './img/logo-big.svg';

function BoxPage() {
  const [boxOpen,setBoxOpen]=useState(false)
  const [start,setStart]=useState(false)
  const [links, setLinks] = useState({});

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  if (localStorage.getItem("hideBoxTitle") === "true") {
    var boxTitleDiv = document.querySelector('.box-title');
    if (boxTitleDiv) {
        boxTitleDiv.style.display = 'none';
    }
}

  const settings={
    //repeat animation for every open?
    replayAnim:false,
    //dalay before opening
    startTimeout:2200
  }

  // ANALYTICS START
  var detectCurrentDevice = localStorage.getItem('deviceDetected');
  useEffect(() => {
    window.tc_vars = {
      'channel': detectCurrentDevice,
      'environment': "stg",
      'pagetemplate': "Valentino Lovely Courting Experience: Choose flavor",
      'site_languagecode': currentLanguage,
      '404': false,
      'pagename': "V:" + currentLanguage + ":valentine:choose-flavor"
    };
    window._satellite.track('virtual_page_load', window.tc_vars);
    console.log("tc_vars", window.tc_vars);
    console.log("virtual_page_load", "activated");
    var headerWhite = document.querySelector('.wrap-header');
    headerWhite.classList.remove('white-header');
    headerWhite.classList.add('box-header');
    const loaderPage = document.querySelector('.preload.active');
    setTimeout(function() {
      if (loaderPage) {
        loaderPage.classList.remove('active');
      }
    }, 500);
  }, []);
  // ANALYTICS END

  const linksMenCn = { // MEN CHINA
    1: "/flavor/c-men-racing-hearts", 
    2: "/flavor/c-men-kindred-spirits", 
    3: "/flavor/c-men-kindred-spirits", 
    4: "/flavor/c-men-racing-hearts", 
    5: "/flavor/c-men-bursting-with-love", 
    6: "/flavor/c-men-soul-mates", 
    7: "/flavor/c-men-most-loved", 
    8: "/flavor/c-men-soul-mates", 
    9: "/flavor/c-men-most-loved", 
  };
  
  const linksWomenCn = { // WOMEN CHINA
    1: "/flavor/c-women-sweet-embrace", 
    2: "/flavor/c-women-passionate-purple", 
    3: "/flavor/c-women-head-over-heels", 
    4: "/flavor/c-women-unlikely-match", 
    5: "/flavor/c-women-unlikely-match", 
    6: "/flavor/c-women-lovestruck", 
    7: "/flavor/c-women-head-over-heels", 
    8: "/flavor/c-women-fated-for-love", 
    9: "/flavor/c-women-sweet-embrace", 
  };
  
  const linksMenEn = { // MEN GLOBAL
    1: "/flavor/men-racing-hearts",
    2: "/flavor/men-kindred-spirits",
    3: "/flavor/men-sophisticated-soul",
    4: "/flavor/men-from-the-heart",
    5: "/flavor/men-most-loved",
    6: "/flavor/men-bursting-with-love",
    7: "/flavor/men-made-for-you",
    8: "/flavor/men-soul-mates",
    9: "/flavor/men-ultra-exquisite",
  };
  
  const linksWomenEn = { // WOMEN GLOBAL
    1: "/flavor/women-love-at-first-sight",
    2: "/flavor/women-passionate-purple",
    3: "/flavor/women-sparks-will-fly",
    4: "/flavor/women-blooming-bouquet",
    5: "/flavor/women-sweet-embrace",
    6: "/flavor/women-lovestruck",
    7: "/flavor/women-head-over-heels",
    8: "/flavor/women-fated-for-love",
    9: "/flavor/women-pure-instinct",
  };

  useEffect(() => {
    const selectedGender = localStorage.getItem('selectedGender');
    if (selectedGender === 'MEN') {
      setLinks(linksMenEn);
    } else if (selectedGender === 'WOMEN') {
      setLinks(linksWomenEn);
    }
    // Optionally, handle case where selectedGender is not set or invalid
    const cookieContainer = document.querySelector('.modal--cookie');
    const boxTitleDiv = document.querySelector('.box-title');
    const flavorDiv = document.querySelector('.select-flavour-btn');
    flavorDiv.style.visibility = 'hidden';
    flavorDiv.style.opacity = '0';
    cookieContainer.classList.add('box-page-cookie');
    boxTitleDiv.classList.add('visible-box');
    setTimeout(function() {
      //boxTitleDiv.classList.add('fade-out');
    }, 500); 

    if (localStorage.getItem("hideBoxTitle") === "true") {
      flavorDiv.style.visibility = 'visible';
      flavorDiv.style.opacity = '1';
    } else {
      setTimeout(function() {
        flavorDiv.style.visibility = 'visible';
        flavorDiv.style.opacity = '1';
      }, 3500);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("fromWizard", "true");
  }, []);

  subscribe(state,()=>{
    if (state.modelReady) {
    setStart(true)}
  })

  return (
    <div>
  
  <div className="wrapper wrapper--page wrapper--page-choice">
    <div className="modal-content modal-content--3d">
      <div className="box-title">
        <div>
          <h2>
            <span>LOVELY</span>
            <br />COURTING
          </h2>
        </div>
      </div>
    </div>
      <ThreeBoxComponent boxData={{links,settings}}/>
      <div className="select-flavour-btn">{t('CHOOSE_CHOCO_LABEL')}</div>
      <div className="overflow-bg" /></div>
      <div className="preload active">
        <picture className="preload__cta-img">
          <img src={logoBig} width={160} height={89}  alt="" />
        </picture>
      </div>
    </div>
  );
}

export default BoxPage;